import React, { useEffect, useRef } from 'react';
import { Breadcrumb, BreadcrumbGroup } from '@amzn/storm-ui';
import {
  OuterContainer,
  SingleBreadcrumbWrapper,
  TruncatedBreadcrumbWrapper,
} from './style';
import TruncationIconWithPopover from './TruncationIconWithPopover';
import { throttle } from 'src/commons/utils/throttle';
import { useResizeObserver } from 'src/commons/hooks';
import { useBreadcrumbTruncation } from './useBreadcrumbTruncationHandler';
import { useBreadcrumbTruncationContext } from './BreadcrumbTruncationContext';

export const DesktopBreadcrumbs: React.VFC<{
  shouldRenderAppName: boolean | undefined;
}> = ({ shouldRenderAppName = true }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { breadcrumbElementsList, breadcrumbHash } =
    useBreadcrumbTruncationContext();

  const { handleTruncation, truncationIndex } = useBreadcrumbTruncation({
    containerRef,
  });
  const noPageTitleBreadcrumb =
    breadcrumbElementsList[breadcrumbElementsList.length - 1]?.props?.children
      ?.props?.breadcrumb?.label?.length === 0;

  useEffect(handleTruncation, [breadcrumbHash]);

  useResizeObserver(
    throttle(() => {
      // do not handle truncation if container is not mounted.  This scenario occurs
      // because of the 100ms throttling
      if (containerRef.current) {
        handleTruncation();
      }
    }, 100),
    containerRef,
  );

  return (
    <TruncatedBreadcrumbWrapper data-ccx-e2e-id="aac-breadcrumbs">
      <SingleBreadcrumbWrapper>
        <BreadcrumbGroup>
          {shouldRenderAppName && <Breadcrumb />}
          {truncationIndex > -1 && (
            <TruncationIconWithPopover
              breadcrumbsList={breadcrumbElementsList.slice(
                0,
                truncationIndex + 1,
              )}
              allTruncated={
                truncationIndex === breadcrumbElementsList.length - 1
              }
            />
          )}
        </BreadcrumbGroup>
      </SingleBreadcrumbWrapper>
      <OuterContainer
        noPageTitleBreadcrumb={noPageTitleBreadcrumb}
        ref={containerRef}
      >
        <BreadcrumbGroup>
          {breadcrumbElementsList.slice(
            truncationIndex + 1,
            breadcrumbElementsList.length,
          )}
        </BreadcrumbGroup>
      </OuterContainer>
    </TruncatedBreadcrumbWrapper>
  );
};
